const messages = {
    general: {
      missing: 'Please provide the required field',
      invalid: 'The value you provided is invalid'
    }
}

export default messages